import { useEffect, useState } from 'react'
import { Button, Box, Dialog, DialogContent, IconButton } from '@mui/material';
import { MapContainer, TileLayer, Marker, Popup } from 'react-leaflet';
import 'leaflet/dist/leaflet.css';
import L from 'leaflet';
import { LatLngTuple } from 'leaflet';
import { FunctionComponent } from 'react';
import { useNavigate } from "react-router-dom";
import { useTranslation } from 'react-i18next';
import { useLazyGetAllStationListQuery } from "../features/station/StationSlice";
import PhotoSphereViewerComponent from '../components/PhotoSphereViewerComponent';

// Fix Leaflet icon paths
const DefaultIcon = L.icon({
  iconUrl: '/leaflet-images/marker-icon.png',
  iconRetinaUrl: '/leaflet-images/marker-icon-2x.png',
  shadowUrl: '/leaflet-images/marker-shadow.png',
  iconSize: [25, 41],
  iconAnchor: [12, 41],
  popupAnchor: [1, -34],
  shadowSize: [41, 41]
});

L.Marker.prototype.options.icon = DefaultIcon;

const MapView: FunctionComponent = () => {
  const [getAllStationList] = useLazyGetAllStationListQuery();
  const { t } = useTranslation();
  const navigate = useNavigate();
  const position: LatLngTuple = [22.392935755468535, 114.08485884008233];
  const [markerData, setMarkerData] = useState<any[]>([]);
  const [selectedImage, setSelectedImage] = useState<string | null>(null);
  const [selectedStation, setSelectedStation] = useState<string>('');
  const [isImageOpen, setIsImageOpen] = useState(false);

  const handleClosePhoto = () => {
    setIsImageOpen(false);
    setSelectedImage(null);
  };

  const handlePhotoClick = (imageUrl: string) => {
    // console.log("Button clicked for row:", rowData);
    // Add your custom logic here
    setSelectedImage(imageUrl);
    setIsImageOpen(true);
  };

  useEffect(() => {
    try {
      getAllStationList({
      }).then(
        (res) => {
          if (res.status === 'fulfilled') {

            const markerInfo = res?.data.map((item: any) => ({
              id: item?.id,
              Name: item.Name,
              district: item.district,
              area: item.area,
              batteryLevel: item.photoUrl,
              lat: item.lat,
              lon: item.lon,
              latestPhotoUrl: item.latestPhotoUrl
            }))

            setMarkerData(markerInfo);
          }
        }
      )
    } catch (error) {

    }
  }, [])

  return (
    <div style={{ height: '80vh', width: '100%' }}>
      <MapContainer
        center={position}
        zoom={11}
        style={{ height: '100%', width: '100%' }}
      >
        <TileLayer
          attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
          url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
        />
        <Dialog
          open={isImageOpen}
          onClose={handleClosePhoto}
          maxWidth="lg"
          fullWidth
          PaperProps={{ sx: { borderRadius: 3 } }}
        >
          <DialogContent sx={{ padding: 2 }}>
            <Box sx={{ position: 'relative' }}>
              <IconButton
                onClick={handleClosePhoto}
                sx={{
                  position: 'absolute',
                  right: 8,
                  top: 8,
                  color: 'white',
                  bgcolor: 'rgba(0,0,0,0.5)',
                  '&:hover': { bgcolor: 'rgba(0,0,0,0.7)' }
                }}
              >
              </IconButton>
              {/* <img
                src={selectedImage || ''}
                alt="Full preview"
                style={{
                  width: '100%',
                  height: 'auto',
                  maxHeight: '80vh',
                  borderRadius: 8
                }}
              /> */}
              {selectedImage && <PhotoSphereViewerComponent stationName={selectedStation} image={selectedImage} title='360 Viewer'/>}
            </Box>
          </DialogContent>
        </Dialog>

        {markerData.map((marker, index) => marker.lat && marker.lon && (
          <Marker key={index} position={[marker.lat, marker.lon]}>
            <Popup>
              <h3>{marker.Name}</h3>
              {/* <p>{marker.content}</p> */}

              {marker.latestPhotoUrl ? <Box
                sx={{
                  width: 60,
                  height: 60,
                  borderRadius: 1,
                  overflow: 'hidden',
                  cursor: 'pointer',
                  '&:hover': {
                    boxShadow: 2,
                    transform: 'scale(1.05)'
                  },
                  transition: 'all 0.2s'
                }}
                onClick={(e) => {
                  e.stopPropagation();
                  setSelectedStation(marker.Name);
                  handlePhotoClick(marker.latestPhotoUrl);
                }}
              >
                <img
                  src={`${marker.latestPhotoUrl}?token=${localStorage.getItem('accessToken')}`}
                  alt="Thumbnail"
                  style={{
                    width: '100%',
                    height: '100%',
                    objectFit: 'cover'
                  }}
                />
              </Box>
                :
                <h4>{t('No Latest Photo')}</h4>
              }
              <p><Button variant="outlined" onClick={() => navigate('/recordDetail?stationName='.concat(marker.Name))}>{t("Record Detail")}</Button></p>
              <p><Button variant="outlined" onClick={() => navigate('/summary?Name='.concat(marker.Name))}>{t("Summary")}</Button></p>
            </Popup>
          </Marker>
        ))}

      </MapContainer>
    </div>
  );
};

export default MapView;